import React from 'react'

export function TitleBarCenterContainer({
  children,
}: {
  readonly children: React.ReactNode
}) {
  return (
    <div
      className={
        'col-start-2 row-start-1 flex flex-col justify-center items-center'
      }
    >
      {children}
    </div>
  )
}
